import React from 'react';
import moment from 'moment';
import numeral from 'numeral';
import { apiPost } from '../../services/apiClient';
import { getRoles } from '../../services/userRights';
import Grid from '../../grid/grid.jsx';
import Forbidden from '../forbidden/forbidden.jsx';
import {costFormat} from "../../services/cost";

export default class BorderInsurance extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0,
            disableFilters: false,
            lastResponseError: null,
            columns: [
                {
                    title: 'Дата создания',
                    fieldName: 'createdDate',
                    filterType: 'date',
                    minWidth: 120
                },
                {
                    title: 'Внутренний номер посылки',
                    fieldName: 'number',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Внешний номер посылки',
                    fieldName: 'externalNumber',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Тип груза',
                    fieldName: 'parcelType',
                    filterType: 'dropdown',
                    loadUrl: 'borderInsurance/ref/parceltypes',
                    minWidth: 120
                },
                {
                    title: 'Выгодопри- обретатель',
                    fieldName: 'beneficiary',
                    filterType: 'none',
                    disableSort: true,
                    minWidth: 120
                },
                {
                    title: 'Наименование груза',
                    fieldName: 'cargoDescription',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: '№№ и Даты инвойсов или контрактов',
                    fieldName: 'invoices',
                    filterType: 'none',
                    disableSort: true,
                    minWidth: 160
                },
                {
                    title: 'Количество мест',
                    fieldName: 'packagesCount',
                    filterType: 'number',
                    minWidth: 120,
                    cellClass: "text-right"
                },
                {
                    title: 'Страховая сумма, руб.',
                    fieldName: 'declaredCargoValue',
                    filterType: 'number',
                    minWidth: 120,
                    cellClass: "text-right"
                },
                {
                    title: 'Страховая премия, руб.',
                    fieldName: 'insuranceCost',
                    filterType: 'number',
                    minWidth: 120,
                    cellClass: "text-right"
                },
                {
                    title: '№№ и Даты отгрузочных документов',
                    fieldName: 'departureDate',
                    filterType: 'date',
                    minWidth: 120
                },
                {
                    title: 'Пункт отправления',
                    fieldName: 'shipmentAddress',
                    filterType: 'string',
                    minWidth: 180
                },
                {
                    title: 'Пункт назначения',
                    fieldName: 'deliveryAddress',
                    filterType: 'string',
                    minWidth: 180
                },
                {
                    title: 'Стоимость услуги страхования для клиента, руб.',
                    fieldName: 'actualInsuranceCost',
                    filterType: 'number',
                    minWidth: 160,
                    cellClass: "text-right"
                }
            ]
        };
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    loadData(settings, takeCount, skipCount, needOverlay) {
        this.updateBusyCount(needOverlay ? 1 : 0);
        return apiPost('borderInsurance/list', { settings: settings, takeCount, skipCount })
            .then(data => {
                this.updateBusyCount(needOverlay ? -1 : 0);
                return data.entries;
            })
            .catch(err => {
                this.updateBusyCount(needOverlay ? -1 : 0);
                if (err.status > 401) {
                    this.setState({ lastResponseError: err.status });
                }
            });
    }

    downloadExcel() {
        this.updateBusyCount(1);
        let settings = this.grid.getSettings();
        apiPost('borderInsurance/excel', { settings: settings })
            .then(data => {
                this.updateBusyCount(-1);
                let fileUrl = getApiBaseUrl() + 'files/' + data.result;
                window.location.href = fileUrl;
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    renderCellValue(row, column) {
        switch (column.fieldName) {
            case 'createdDate':
                return moment(row.createdDate).format("DD.MM.YYYY HH:mm");
            case 'departureDate':
                return moment(row.departureDate).format("DD.MM.YYYY");
            case 'declaredCargoValue':
                return row.declaredCargoValue ? costFormat(numeral(row.declaredCargoValue).format("0.00")) : '';
            case 'insuranceCost':
                return row.insuranceCost ? costFormat(numeral(row.insuranceCost).format("0.00")) : '';
            case 'actualInsuranceCost':
                return row.actualInsuranceCost ? costFormat(numeral(row.actualInsuranceCost).format("0.00")) : '';
            default:
                return row[column.fieldName];
        }
    }

    render() {
        let roles = getRoles();
        let hasAccess = roles.includes('Coordinator');
        if (!hasAccess || this.state.lastResponseError === 403) {
            return <Forbidden />;
        }

        let isBusy = this.state.busyCount > 0;

        return (
            <div>
                <section className="content-header">
                    <h1>
                        Бордеро страхования
                    </h1>
                    <ol className="breadcrumb">
                        <li className="active">Бордеро страхования</li>
                    </ol>
                </section>
                <section className="content">
                    <div className="box grid-box" style={{ height: this.state.boxHeight }}>
                        <div className="box-header">
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.grid.reload()}
                                    disabled={isBusy}
                                >
                                    <span className="fa fa-refresh"></span> Обновить
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.grid.clearSettings()}
                                    disabled={isBusy}
                                >
                                    <span className="glyphicon glyphicon-remove"></span> Сбросить
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.downloadExcel()}
                                    disabled={isBusy}
                                >
                                    <span className="glyphicon glyphicon-save-file"></span> Excel
                                </a>
                            </div>
                        </div>
                        <div className="box-body">
                            <Grid columns={this.state.columns}
                                loadData={(settings, take, skip, needOverlay) => this.loadData(settings, take, skip, needOverlay)}
                                isBusy={isBusy}
                                disableFilters={this.state.disableFilters}
                                gridKey="border-insurance"
                                renderCellValue={(row, column) => this.renderCellValue(row, column)}
                                ref={grid => this.grid = grid}
                            />
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/insurance/borderInsurance.jsx